module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Bold.859bd02c.woff2";